import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RetailHubHomeComponent } from '../Dashboard/components/home/retailhub-home.component';
import { RetailHubManageProjectsComponent } from '../Dashboard/components/manage-projects/retailhub-manage-projects.component';
import { RetailHubManageSalesplanComponent } from '../Dashboard/components/manage-salesplan/retailhub-manage-salesplan.component';
import { RoleKey } from '../Common/Constants/common.constants';
import { authGuard } from '../Common/guards/auth.guard';
import { RetailhubAdhocTemplateComponent } from './components/adhoc-template/retailhub-adhoc-template.component';
const routes: Routes = [
  {
    path: 'home',
    component: RetailHubHomeComponent,
    canActivate: [authGuard],
    data: {
      expectedRole: [RoleKey.ITAdmin, RoleKey.SREAdmin, RoleKey.SRESupport, RoleKey.CustomerTeam]
    }
  },
  {
    path: 'manage-projects',
    component: RetailHubManageProjectsComponent,
    canActivate: [authGuard],
    data: {
      expectedRole: [RoleKey.SREAdmin, RoleKey.SRESupport, RoleKey.CustomerTeam]
    }
  },
  {
    path: 'manage-salesplan',
    component: RetailHubManageSalesplanComponent,
    canActivate: [authGuard],
    data: {
      expectedRole: [RoleKey.SREAdmin, RoleKey.SRESupport, RoleKey.CustomerTeam]
    }
  },
  {
    path: 'adhoc-template',
    component: RetailhubAdhocTemplateComponent,
    canActivate: [authGuard],
    data: {
      expectedRole: [RoleKey.SREAdmin, RoleKey.SRESupport, RoleKey.CustomerTeam]
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
